import React, { useRef } from "react";
import { ALLOWED_SVG_EXTENSIONS } from "../../utils/image/image-constants";
import { readFileAsText, validateSvgFile } from "../../utils/image/image-file-utils";
import ImagePreviewRemove from "./ImagePreviewRemove";

export default function SingleSvgUpload({
    value,
    onChange,
    t,
    disabled = false,
    onError,
}) {
    const inputRef = useRef(null);

    const handleSelectFile = async (event) => {
        const file = event.target.files?.[0];
        event.target.value = "";
        if (!file) return;

        const validation = validateSvgFile(file);
        if (!validation.valid) {
            onError?.(t(validation.key));
            return;
        }

        try {
            const svgContent = await readFileAsText(file);
            if (!svgContent.trim().startsWith("<svg")) {
                onError?.(t("alert_svg_formato_invalido"));
                return;
            }
            onChange(svgContent.trim());
        } catch (err) {
            onError?.(err.message ?? t("alert_process_failed"));
        }
    };

    return (
        <div>
            {!value && (
                <label className="flex flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-slate-300 bg-slate-50 px-4 py-8 text-center cursor-pointer hover:border-ct-primary-400 hover:bg-ct-primary-50/30 transition">
                    <span className="text-2xl" aria-hidden>📄</span>
                    <span className="text-sm font-semibold text-slate-700">{t("label_seleccionar_svg")}</span>
                    <span className="text-xs text-slate-500">{t("label_svg_max_5mb")}</span>
                    <input
                        ref={inputRef}
                        type="file"
                        accept={ALLOWED_SVG_EXTENSIONS.join(",")}
                        className="sr-only"
                        disabled={disabled}
                        onChange={handleSelectFile}
                    />
                </label>
            )}

            <ImagePreviewRemove
                value={value}
                alt={t("label_imagen_principal")}
                onRemove={() => onChange("")}
                disabled={disabled}
                removeLabel={t("label_eliminar_imagen")}
            />
        </div>
    );
}
